// StatusCell.tsx (or StatusCell.js)

import React from "react";
import { Tooltip, IconButton } from "@mui/material";
import {
  IconStatusFail,
  IconStatusInprogress,
  IconStatusNew,
  IconStatusPass,
} from "../../common/utils/icons";

interface StatusCellProps {
  status: string;
}

const StatusCell: React.FC<StatusCellProps> = ({ status }) => {
  const statusType = status?.replace(" ", "")?.toLowerCase();

  if (statusType === "new") {
    return (
      <Tooltip title="New" placement="top" arrow>
        <IconButton
          className="datagrid-action-btn p-0"
          color="inherit"
          aria-label="Status: New"
          data-testid="status-new-icon"
        >
          <IconStatusNew />
        </IconButton>
      </Tooltip>
    );
  }

  if (statusType === "inprogress") {
    return (
      <Tooltip title="In Progress" placement="top" arrow>
        <IconButton
          className="datagrid-action-btn p-0"
          color="inherit"
          aria-label="Status: In Progress"
          data-testid="status-inprogress-icon"
        >
          <IconStatusInprogress />
        </IconButton>
      </Tooltip>
    );
  }

  if (statusType === "acknowledged") {
    return (
      <Tooltip title="Acknowledged" placement="top" arrow>
        <IconButton
          className="datagrid-action-btn p-0"
          color="inherit"
          aria-label="Status: Acknowledged"
          data-testid="status-acknowledged-icon"
        >
          <IconStatusFail />
        </IconButton>
      </Tooltip>
    );
  }

  if (statusType === "closed" || statusType === "auto_closed") {
    return (
      <Tooltip title="Closed" placement="top" arrow>
        <IconButton
          className="datagrid-action-btn p-0"
          color="inherit"
          aria-label="Status: Resolved"
          data-testid="status-resolved-icon"
        >
          <IconStatusPass />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Tooltip title="New" placement="top" arrow>
      <IconButton
        className="datagrid-action-btn p-0"
        color="inherit"
        aria-label="Status: Unknown"
        data-testid="status-unknown-icon"
      >
        <IconStatusNew />
      </IconButton>
    </Tooltip>
  );
};

export default StatusCell;
